import { Component, OnInit } from '@angular/core';

import { SimpleComponent } from '../../common/simple.component';

@Component({
	selector: 'app-users-departments',
	templateUrl: './users-departments.component.html',
	styleUrls: ['./users-departments.component.css'],
})
export class UsersDepartmentsComponent extends SimpleComponent {
	protected apiUrl = 'departments';
	elements: Array<Departments> = [];
	data: Departments = {
		id: null,
		name: null,
	};
	tableRows = [{ id: 'name', name: 'Nazwa' }];

	protected resetData(): void {
		this.data = {
			id: null,
			name: '',
		};
	}
}
export interface Departments {
	id: number;
	name: string;
}
